import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260124_plan_view_level_ids",
  description: "Convert PlanView levelIds from string[] to InstanceScopedNamespacePath[]",
  apply(json: any): any {
    const { planViews = {} } = json;

    for (const viewId in planViews) {
      const view = planViews[viewId];
      if (view.levelIds && Array.isArray(view.levelIds)) {
        view.levelIds = view.levelIds.map((id: any) => {
          // Already migrated (object with entityId)
          if (typeof id === "object" && id.entityId) {
            return id;
          }
          // Old format (string)
          return { entityId: id };
        });
      }
    }

    return json;
  },
};

export default migration;
